export default "__VITE_ASSET__Deo$VBcS__"